import t from 'tcomb-form'
import { isObject } from 'util'
import moment from 'moment'
import DatePickerFactory from '../containers/formTemplate/datepickerfactory'
import { WBSCode } from '../components/tcomb/wbccode'
import { LookAheadStatuses } from './helpers/AllTasksScreen'

const deliveryStatus = t.enums({
    PickUp: 'Needs Pick Up',
    Transit: 'In Transit',
    Arrived: 'Arrived'
})

export const WeekFilters = {
    7: 'Next 7 Days',
    14: 'Next 2 Weeks',
    21: 'Next 3 Week',
    42: 'Next 6 Week',
    70: 'Next 10 Week'
}

const deliveryAlertOptions = t.maybe(
  t.enums({
      None: 'None',
      At_time: 'At time of event',
      '5_min_before': '5 minutes before',
      '15_min_before': '15 minutes before',
      '30_min_before': '30 minutes before',
      '1_hour_before': '1 hour before',
      '2_hour_before': '2 hours before',
      '1_day_before': '1 day before',
      '2_days_before': '2 days before'
  })
)

export const progressEnum = {
    '0': '0%',
    '10': '10%',
    '20': '20%',
    '30': '30%',
    '40': '40%',
    '50': '50%',
    '60': '60%',
    '70': '70%',
    '80': '80%',
    '90': '90%',
    '100': '100%'
}

export const progressOptions = t.enums({
    '0': '0%',
    '10': '10%',
    '20': '20%',
    '30': '30%',
    '40': '40%',
    '50': '50%',
    '60': '60%',
    '70': '70%',
    '80': '80%',
    '90': '90%',
    '100': '100%'
})

export const LookAheadStatusOptions = t.enums(LookAheadStatuses)

//Delivery
const deliveryFormTemplate = [
    {
        label: 'Name',
        type: t.String,
        formKey: 'delivery_name'
    },
    {
        label: 'Status',
        type: deliveryStatus,
        formKey: 'delivery_status'
    },
    {
        label: 'Quantity',
        type: t.maybe(t.Number),
        formKey: 'quantity'
    },
    {
        label: 'Cost Impact',
        type: t.maybe(t.Number),
        formKey: 'costImpact'
    },
    {
        label: 'timeSpan',
        type: 'timeSpan',
        formKey: 'timeSpan'
    },
    {
        label: 'Alert',
        type: deliveryAlertOptions,
        formKey: 'delivery_alert'
    },
    {
        label: 'assignees',
        type: 'assignees',
        formKey: 'delivery_assignees'
    },
    {
        label: 'Files',
        type: 'files',
        formKey: 'delivery_files'
    },
    {
        label: 'qrcode',
        type: 'qrcode',
        formKey: 'qrcode'
    },
    {
        label: 'taskDependencies',
        type: 'taskDependencies',
        formKey: 'taskDependencies'
    }
]

export function getDeliveryFormTemplate(activityList, siteLocationList) {
    const formTemplate = deliveryFormTemplate.slice()
    const activityMap = activityList.reduce((obj, value) => {
      obj[value.uid] = value.name
      return obj
  }, {})
    const siteLocationMap = siteLocationList.reduce((obj, value) => {
      obj[value.uid] = value.name
      return obj
  }, {})

    formTemplate.unshift({
      label: 'Activity',
      type: t.maybe(t.enums(activityMap)),
      formKey: 'activityId'
  })

    formTemplate.push({
      label: 'Site Location',
      type: t.maybe(t.enums(siteLocationMap)),
      formKey: 'siteLocationId'
  })
    return formTemplate
}

export function getDeliveryEntityRoute(projectId, deliveryId) {
    return `/projects/${projectId}/deliveries/${deliveryId}`
}

//End Delivery

//Activity

const activityFormTemplate = [
    {
        label: 'Name',
        type: t.String,
        formKey: 'name'
    }
]

export function getActivityEntityRoute(projectId, activityId) {
    return `/projects/${projectId}/activities/${activityId}`
}

export function getActivityFormTemplate() {
    return activityFormTemplate.slice()
}
//End Activity

//SiteLocation

const siteLocationFormTemplate = [
    {
        label: 'Name',
        type: t.String,
        formKey: 'name'
    }
]
export function getSiteLocationEntityRoute(projectId, siteLocationId) {
    return `/projects/${projectId}/siteLocations/${siteLocationId}`
}

export function getSiteLocationFormTemplate() {
    return siteLocationFormTemplate.slice()
}
//End SiteLocation

// Task
const taskFormTemplate = [
    {
        label: 'WBS Code',
        type: t.maybe(t.String),
        formKey: 'code',
    },
    {
        label: 'Name',
        type: t.String,
        formKey: 'name',
    },
    {
        label: 'Progress',
        type: progressOptions,
        formKey: 'progress'
    },
    {
        label: 'Description',
        type: t.maybe(t.String),
        formKey: 'description'
    },
    {
        label: 'timeSpan',
        type: 'timeSpan',
        formKey: 'timeSpan'
    },
    {
        label: 'assignees',
        type: 'assignees',
        formKey: 'watchers'
    },
    {
        label: 'Files',
        type: 'files',
        formKey: 'delivery_files'
    },
    {
        label: 'qrcode',
        type: 'qrcode',
        formKey: 'qrcode'
    },
    {
        label: 'taskDependencies',
        type: 'taskDependencies',
        formKey: 'taskDependencies'
    }
]
export function getTaskEntityRoute(projectId, taskId) {
    return `/projects/${projectId}/tasks/${taskId}`
}

export function getTaskFormTemplate() {
    const formTemplate = taskFormTemplate.slice()

    return formTemplate
}

// End Task

// Equipment
const equipmentFormTemplate = [
    {
        label: 'Name',
        type: t.String,
        formKey: 'name'
    },
    {
        label: 'Description',
        type: t.maybe(t.String),
        formKey: 'description'
    },
    {
        label: 'Files',
        type: 'files',
        formKey: 'delivery_files'
    },
    {
        label: 'qrcode',
        type: 'qrcode',
        formKey: 'qrcode'
    }
]
export function getEquipmentEntityRoute(projectId, id) {
    return `/projects/${projectId}/equipment/${id}`
}

export function getEquipmentFormTemplate() {
    return equipmentFormTemplate.slice()
}
// End Equipment

// Equipment Schedule
const equipmentScheduleFormTemplate = [
    {
        label: 'Progress',
        type: progressOptions,
        formKey: 'progress'
    },
    {
        label: 'timeSpan',
        type: 'timeSpan',
        formKey: 'timeSpan'
    },
    {
        label: 'Cost Impact',
        type: t.maybe(t.Number),
        formKey: 'costImpact'
    },
    {
        label: 'Note',
        type: t.maybe(t.String),
        formKey: 'note'
    },
    {
        label: 'assignees',
        type: 'assignees',
        formKey: 'watchers'
    },
    {
        label: 'qrcode',
        type: 'qrcode',
        formKey: 'qrcode'
    },
    {
        label: 'taskDependencies',
        type: 'taskDependencies',
        formKey: 'taskDependencies'
    }
]
export function getEquipmentScheduleEntityRoute(projectId, id) {
    return `/projects/${projectId}/equipment_schedule/${id}`
}

export function getEquipmentScheduleFormTemplate(activityList, equipmentList) {
    const formTemplate = equipmentScheduleFormTemplate.slice()
    const activityMap = activityList.reduce((obj, value) => {
      obj[value.uid] = value.name
      return obj
  }, {})
    const equipmentMap = equipmentList.reduce((obj, value) => {
      obj[value.uid] = value.name
      return obj
  }, {})

    formTemplate.unshift({
      label: 'Equipment',
      type: t.enums(equipmentMap),
      formKey: 'equipmentId'
  })

    formTemplate.unshift({
      label: 'Activity',
      type: t.maybe(t.enums(activityMap)),
      formKey: 'activityId'
  })
    return formTemplate
}
// End Equipment Schedule

function mapDeliveryStatusToProgress(status) {
    if (status === 'PickUp') {
      return 0
  } else if (status === 'Transit') {
      return 50
  } else {
      return 100
  }
}

export function dockPadEntityMapToList(entityMap) {
    const list = []
    for (const key in entityMap) {
        const item = entityMap[key]
        if (!isObject(item)) continue
        item.uid = key
        list.push(item)
    }
    return list
}

export function formatDockPadEntityToGanttTask(entities, type, entityType) {
    const entityMap = {}
    const retEntities = entities.map(item => {
      let progress = 0
      if (!!item.delivery_status) {
        progress = mapDeliveryStatusToProgress(item.delivery_status)
    } else {
        progress = !!item.progress ? item.progress : 0
    }

      let name = ''

      if (!!item.delivery_name) {
        name = item.delivery_name
    } else {
        name = item.name
    }

      let startTime = moment().format('YYYY-MM-DD')
      let endTime = moment().format('YYYY-MM-DD')

      let startTimeValue = moment().valueOf()
      let endTimeValue = moment().valueOf()
      let duration = 1
      if (
      !!item.timeSpan &&
      !!item.timeSpan.start_time &&
      !!item.timeSpan.end_time
    ) {
        const startMoment = moment(item.timeSpan.start_time)
        const endMoment = moment(item.timeSpan.end_time)

        startTime = startMoment.format('YYYY-MM-DD')
        endTime = endMoment.format('YYYY-MM-DD')
        startTimeValue = startMoment.valueOf()
        endTimeValue = endMoment.valueOf()

        duration = endMoment.diff(startMoment, 'days') + 1
    }

      const dependencies = !!item.dependencies
      ? Object.keys(item.dependencies)
      : []

      const activityId = !item.activityId ? 'General' : item.activityId
      return {
        code: item.code,
        id: item.uid,
        uid: item.uid,
        activityId: activityId,
        name: name,
        progress: !!progress ? progress : 0,
        costImpact: item.costImpact,
        start: startTime,
        end: endTime,
        startMs: startTimeValue,
        endMs: endTimeValue,
        status: deliveryStatus[item.delivery_status],
        type: type,
        duration: duration,
        entityType: entityType,
        dependencies: dependencies,
        assignees: !!item.assignees ? item.assignees : {},
        successors: [],
        predecessors: [],
        earlyStartTime: null,
        earlyFinishTime: null
    }
  })

    return retEntities

  /*retEntities.forEach(item => {
        entityMap[item.id] = item
    })


    const start = {
        id: 'start',
        earlyStartTime: 0,
        earlyFinishTime: 0,
        lastStartTime: 0,
        lastFinishTime: 0,
        totalSlack: 0,
        duration: 0,
        successors: [],
        predecessors: []
    };
    const end = {
        id: 'end',
        earlyStartTime: 0,
        earlyFinishTime: 0,
        lastStartTime: 0,
        lastFinishTime: 0,
        totalSlack: 0,
        duration: 0,
        successors: [],
        predecessors: []
    };

    const withSuccessors = retEntities.map(item => {
        const predecessorsIds = item.dependencies
        const predecessors = [];
        if (predecessorsIds.length === 0) {
            predecessors.push(start);
            start.successors.push(item);
        } else {
            for(const j in predecessorsIds) {
                const previous = entityMap[predecessorsIds[j]];
                if (!previous) {
                    throw new Error('Node ' + j + ' dont exists');
                }
                predecessors.push(previous);
                previous.successors.push(item);
            }
        }
        item.predecessors = predecessors

        return item
    })

    const withPredessor = withSuccessors.map(item => {
        const successors = item.successors;
        if (successors.length === 0) {
            successors.push(end)
            end.predecessors.push(item)
        }
        item.successors = successors

        return item
    })


    setEarlyTimes(start)

    end.lastFinishTime = end.earlyFinishTime
    end.lastStartTime = end.lastFinishTime - end.duration
    end.totalSlack = end.earlyFinishTime - end.lastFinishTime

    const criticalPath = new Set()
    setLateTimes(start, criticalPath)

    let path = {
        id: end.id,
        duration: end.duration,
        lastFinishTime: end.lastFinishTime,
        lastStartTime: end.lastStartTime,
        earlyFinishTime: end.earlyFinishTime,
        earlyStartTime: end.earlyStartTime,
        totalSlack: end.totalSlack,
        predecessors: []
    }
    buildCriticalPath(end, path, start);

    return withPredessor*/
}

function buildCriticalPath(root, path, start) {
    if (root.totalSlack === 0) {
      const predecessors = root.predecessors
      for (const i in predecessors) {
        const node = predecessors[i]
        if (node.totalSlack === 0) {
          const clone = {
            id: node.id,
            name: node.name,
            duration: node.duration,
            totalSlack: node.totalSlack
        }
        //Dont add start ... its just a fake node
          if (node !== start) {
            if (!path.predecessors) {
              path.predecessors = []
          }
            path.predecessors.push(clone)
            buildCriticalPath(node, clone, start)
        }
      }
    }
  }
}

function setEarlyTimes(root) {
    for (const i in root.successors) {
      const node = root.successors[i]

      const predesessors = node.predecessors
      for (const j in predesessors) {
        const activity = predesessors[j]
        if (
        node.earlyStartTime == null ||
        node.earlyStartTime < activity.earlyFinishTime
      ) {
          node.earlyStartTime = activity.earlyFinishTime
      }
    }
      node.earlyFinishTime = node.earlyStartTime + node.duration
      setEarlyTimes(node)
  }
}

function setLateTimes(root, cp) {
    if (root.successors.length == 0) {
      root.lastFinishTime = root.earlyFinishTime
      root.lastStartTime = root.lastFinishTime - root.duration
      root.totalSlack = root.earlyFinishTime - root.lastFinishTime
  } else {
      for (const i in root.successors) {
        const node = root.successors[i]
        setLateTimes(node, cp)
        if (
        root.lastFinishTime == null ||
        root.lastFinishTime > node.lastStartTime
      ) {
          root.lastFinishTime = node.lastStartTime
      }
    }

      root.lastStartTime = root.lastFinishTime - root.duration
      root.totalSlack = root.lastFinishTime - root.earlyFinishTime

      if (root.totalSlack === 0 && root.id !== 'start' && root.id !== 'end') {
        cp.add({ id: root.id, name: root.name })
    }
  }
}

export function getDoneTasks(tasks) {
    return tasks.filter(item => item.progress == 100)
}

export function getPendingTasks(tasks) {
    return tasks.filter(item => item.progress == 0)
}

export function getInProgressTasks(tasks) {
    return tasks.filter(item => item.progress > 0 && item.progress < 100)
}

export function getUpcomingTasks(tasks, startOfFilter, endOfFilter) {
    return tasks.filter(item => {
      return (
      (item.startMs >= startOfFilter && item.startMs <= endOfFilter) ||
      (item.endMs >= startOfFilter && item.endMs <= endOfFilter)
    )
  })
}

export function getAtRiskTasks(tasks) {
    const now = moment()
    const atRiskTasks = tasks
    .filter(item => item.progress < 100)
    .filter(item => {
      const startDate = moment(item.startMs)
      const endDate = moment(item.endMs)
      const daysTotal = endDate.diff(startDate, 'days')
      const daysPassed = now.diff(startDate, 'days')

      const currentProgress = item.progress
      const remainingProgress = 100 - item.progress
      const expectedRemaingDays =
        (remainingProgress * daysPassed) / currentProgress
      const actualRemainingDays = daysTotal - daysPassed
      if (daysPassed < 0) {
        return false
      }
      return expectedRemaingDays > actualRemainingDays
    })
    .map(item => {
        item['risk_reason'] = 'Slow Progress'
        return item
    })
    const atRiskIds = new Set(atRiskTasks.map(item => item.uid))

    const atRiskDep = tasks
    .filter(item => {
      return item.dependencies.some(dep => atRiskIds.has(dep))
    })
    .map(item => {
        if (!!item.risk_reason) return item
        item['risk_reason'] = "Parent's Risk"
        return item
    })
    return [...new Set([...atRiskDep, ...atRiskTasks])]
}

export function processformStruct(options, formTemplate) {
    options['fields'] = {}
    const formStruct = {}
    for (let formItem of formTemplate) {
      if (formItem.type === 'files') {
        continue
    }
      if (formItem.type === 'assignees') {
        continue
    }

      if (formItem.type === 'qrcode') {
        continue
    }

      if (formItem.type === 'taskDependencies') {
        continue
    }

      if (formItem.type === 'lookahead_status') {
        continue
    }

      if (processTimeSpan(options, formItem, formStruct)) {
        continue
    }

      processFormItem(options, formItem, formStruct)
  }
    return formStruct
}

export const startTimeFormKey = 'start_time'
export const endTimeFormKey = 'end_time'

export const dateTransformer = {
    format: value => value,
    parse: str => {
      return str ? moment(str).valueOf() : moment().valueOf()
  }
}

function processFormItem(options, formItem, formStruct) {
    options['fields'][formItem.formKey] = {
      label: formItem.label
  }
    if (!!formItem.mode) {
      options['fields'][formItem.formKey]['mode'] = formItem.mode
  }
    formStruct[formItem.formKey] = formItem.type
    if (!!formItem.factory) {
      options['fields'][formItem.formKey]['transformer'] = dateTransformer
      options['fields'][formItem.formKey]['factory'] = formItem.factory
  }
}

function processTimeSpan(options, formItem, formStruct) {
    if (formItem.type !== 'timeSpan') {
      return false
  }

    options['fields']['timeSpan'] = {
      fields: {
        [startTimeFormKey]: {
          label: 'Start Time',
          mode: 'datetime',
          transformer: dateTransformer,
          factory: DatePickerFactory
      },
        [endTimeFormKey]: {
          label: 'End Time',
          mode: 'datetime',
          transformer: dateTransformer,
          factory: DatePickerFactory
      }
    }
  }

    const timeSpanStruct = t.refinement(
    t.struct({
        [startTimeFormKey]: t.Number,
        [endTimeFormKey]: t.Number
    }),
    x => {
        return x[startTimeFormKey] <= x[endTimeFormKey]
    }
  )

    formStruct['timeSpan'] = timeSpanStruct

    return true
}

export const arrayToObject = (array, keyField) =>
  array.reduce((obj, item) => {
      obj[item[keyField]] = item
      return obj
  }, {})



// WEBPACK FOOTER //
// ./src/containers/DockPadFormTemplates.tsx